import * as React from "react"

import Adslot from "../components/Adslot"

const spacer = <div style={{ height: 1000 }} />

const AdsPage: React.FC = () => {
    return <>
        {spacer}
        ART_Billboard_1
        <Adslot name="ART_Billboard_1" />
        {spacer}
        ART_Billboard_2
        <Adslot name="ART_Billboard_2" />
        {spacer}
        ART_intext_1
        <Adslot name="ART_intext_1" />
        {spacer}
        ART_intext_2
        <Adslot name="ART_intext_2" />
        {spacer}
        ART_Halfpage_1
        <Adslot name="ART_Halfpage_1" />
        {spacer}
        ART_Halfpage_2
        <Adslot name="ART_Halfpage_2" />
        {spacer}
    </>
}

export default AdsPage